<template>
  <div>
    <div class="sub-title">{{ $t("menu.forecast") }}</div>
    <!-- <div class="dashboard-update-info" v-if="Forecast_Data">
                <i class="fas fa-sync faa-spin animated faa-slow"></i>
                數值更新： {{ DateTools.Get_DateTimeZone( Forecast_Data.log_time ) }}
            </div> -->
    <div>
      <LoadingInfo v-if="loading"></LoadingInfo>
      <div v-if="Forecast_Data" class="forecast-day-overflow">
        <div class="forecast-day-area">
          <div
            v-for="(day, idx) in Forecast_Data"
            :key="idx"
            class="forecast-day"
          >
            <div>
              <div class="forecast-date">
                {{ $moment(day.log_time).format("MM/DD") }}
                <div class="forecast-weekday">
                  {{
                    $moment(day.log_time).locale(Moment_Locale).format("dddd")
                  }}
                </div>
              </div>

              <div class="forecast-info">
                <div
                  class="forecast-temperature"
                  v-if="
                    day.min_air_temperature != undefined &&
                    day.max_air_temperature != undefined
                  "
                >
                  {{ day.min_air_temperature }} ~ {{ day.max_air_temperature }}℃
                </div>

                <div class="forecast-rain">
                  <div v-if="day.rain_probability != undefined" class="">
                    <i class="wi wi-rain"></i> {{ day.rain_probability }} %
                  </div>
                  {{ day.description }}
                </div>

                <div
                  class="forecast-comfort"
                  v-if="
                    day.min_comfort_descript != undefined &&
                    day.max_comfort_descript != undefined
                  "
                >
                  <!-- 舒適度： -->
                  {{ day.min_comfort_descript }} ~
                  {{ day.max_comfort_descript }}
                </div>

                <div class="forecast-uvi" v-if="day.uvi_description">
                  {{ $t("menu.uv_info") }}：{{ day.uvi_description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p v-if="Forecast_Data" class="data-source mt-2">
        {{ $t("menu.data_source") }}：{{ $t("menu.CWB_forecast") }}
      </p>
    </div>
  </div>
</template>

<script>
import LoadingInfo from "@/components/LoadingInfo";

export default {
  props: {
    field_id: {
      type: [String, Number],
      required: true,
    },
    user_language: {
      type: String,
      default: undefined,
    },
  },
  components: {
    LoadingInfo,
  },
  data() {
    return {
      loading: false,
      Forecast_Data: undefined,
    };
  },
  mounted() {
    this.get_Data();
  },
  computed: {
    Moment_Locale() {
      let _moment_lang = "zh-tw";

      switch (this.user_language) {
        case "en":
          _moment_lang = "en";
          break;
        case "ja":
          _moment_lang = "ja";
          break;
        default:
          break;
      }

      return _moment_lang;
    },
  },
  watch: {
    field_id() {
      this.get_Data();
    },
    user_language() {
      this.get_Data();
    },
  },
  methods: {
    // 取得縮時照片
    get_Data() {
      this.loading = true;
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Field_Forecasts", {
          fieldID: this.field_id,
        }),
      };
      this.$http(options)
        .then((res) => {
          // console.log( res.data )
          this.Forecast_Data = res.data.forecasts;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$flowering-color: #fe6357;
$blooming-color: #232175;

.sub-title {
  display: inline-block;
  padding: 3px 10px;
  color: $blooming-color;
  background-color: rgba($flowering-color, 0.3);
  font-weight: bold;
  border-radius: 2px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.forecast-day-overflow {
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 15px;
}

.forecast-day-area {
  min-width: 150 * 7px;
  border: 1px solid rgba($flowering-color, 0.5);
  border-radius: 5px;
}

.forecast-day {
  display: inline-block;
  text-align: center;
  vertical-align: top;
  width: 148px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 0.8rem;
}

.forecast-date {
  display: inline-block;
  vertical-align: top;
  margin-right: 15px;
  font-weight: 600;
  font-size: 1.2rem;

  .forecast-weekday {
    font-size: 0.8rem;
  }
}

.forecast-info {
  display: inline-block;
  margin-right: 10px;
}
</style>
